module.exports = __webpack_public_path__ + "static/img/take-picture3.ec8759c.png";